export const DON_HANG_STATUS_MAP: Record<string, string> = {
  '0': 'Lập chứng từ',
  '1': 'Chờ duyệt',
  '5': 'Xuất hóa đơn',
  '6': 'Đã xuất hóa đơn điện tử',
  '7': 'Bỏ duyệt đơn hàng'
};

export const DON_HANG_EXPORT_TITLE = 'ĐƠN HÀNG';
export const DON_HANG_SHEET_NAME = 'DonHang';
export const DON_HANG_FILE_NAME = 'Đơn hàng';
